import React from "react";

import { Checkbox, Box } from "@mui/material";

import BaseLabel from "../BaseLabel";

export interface CheckBoxLabelProps {
  id?: string;
  label: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const CheckBoxLabel: React.FC<CheckBoxLabelProps> = ({
  id,
  label,
  checked,
  onChange,
  disabled = false,
}) => (
  <Box display="flex" alignItems="center" gap={1}>
    <Checkbox
      id={id}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
     sx={{padding: 0}}
    />
    <BaseLabel fontSize="14px" marginLeft="0px">
      {label}
    </BaseLabel>
  </Box>
);

export default CheckBoxLabel;
